import _slicedToArray from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var _mediaController;

import { globalThis, document } from "./utils/server-safe-globals.js";
import { MediaUIAttributes, MediaStateReceiverAttributes } from "./constants.js";
import { getOrInsertCSSRule, getStringAttr, setStringAttr } from "./utils/element-utils.js";
var template = document.createElement("template");
template.innerHTML = "\n  <style>\n    :host {\n      box-sizing: border-box;\n      display: var(--media-control-display, var(--media-preview-thumbnail-display, inline-block));\n      overflow: hidden;\n    }\n\n    img {\n      display: none;\n      position: relative;\n    }\n  </style>\n  <img crossorigin loading=\"eager\" decoding=\"async\">\n";

var MediaPreviewThumbnail = /*#__PURE__*/function (_globalThis$HTMLEleme) {
  _inherits(MediaPreviewThumbnail, _globalThis$HTMLEleme);

  var _super = _createSuper(MediaPreviewThumbnail);

  function MediaPreviewThumbnail() {
    var _this;

    _classCallCheck(this, MediaPreviewThumbnail);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _mediaController, void 0);

    if (!_this.shadowRoot) {
      _this.attachShadow({
        mode: "open"
      });

      _this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    return _this;
  }

  _createClass(MediaPreviewThumbnail, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _a, _b, _c;

      var mediaControllerId = this.getAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);

      if (mediaControllerId) {
        __privateSet(this, _mediaController, (_a = this.getRootNode()) == null ? void 0 : _a.getElementById(mediaControllerId));

        (_c = (_b = __privateGet(this, _mediaController)) == null ? void 0 : _b.associateElement) == null ? void 0 : _c.call(_b, this);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _a, _b;

      (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

      __privateSet(this, _mediaController, null);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      var _a, _b, _c, _d, _e;

      if ([MediaUIAttributes.MEDIA_PREVIEW_IMAGE, MediaUIAttributes.MEDIA_PREVIEW_COORDS].includes(attrName)) {
        this.update();
      }

      if (attrName === MediaStateReceiverAttributes.MEDIA_CONTROLLER) {
        if (oldValue) {
          (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

          __privateSet(this, _mediaController, null);
        }

        if (newValue && this.isConnected) {
          __privateSet(this, _mediaController, (_c = this.getRootNode()) == null ? void 0 : _c.getElementById(newValue));

          (_e = (_d = __privateGet(this, _mediaController)) == null ? void 0 : _d.associateElement) == null ? void 0 : _e.call(_d, this);
        }
      }
    }
  }, {
    key: "mediaPreviewImage",
    get: function get() {
      return getStringAttr(this, MediaUIAttributes.MEDIA_PREVIEW_IMAGE);
    },
    set: function set(value) {
      setStringAttr(this, MediaUIAttributes.MEDIA_PREVIEW_IMAGE, value);
    }
  }, {
    key: "mediaPreviewCoords",
    get: function get() {
      var attrVal = this.getAttribute(MediaUIAttributes.MEDIA_PREVIEW_COORDS);
      if (!attrVal) return void 0;
      return attrVal.split(/\s+/).map(function (coord) {
        return +coord;
      });
    },
    set: function set(value) {
      if (!value) {
        this.removeAttribute(MediaUIAttributes.MEDIA_PREVIEW_COORDS);
        return;
      }

      this.setAttribute(MediaUIAttributes.MEDIA_PREVIEW_COORDS, value.join(" "));
    }
  }, {
    key: "update",
    value: function update() {
      var _this2 = this;

      var coords = this.mediaPreviewCoords;
      var previewImage = this.mediaPreviewImage;
      if (!(coords && previewImage)) return;

      var _coords = _slicedToArray(coords, 4),
          x = _coords[0],
          y = _coords[1],
          w = _coords[2],
          h = _coords[3];

      var src = previewImage.split("#")[0];
      var computedStyle = getComputedStyle(this);
      var maxWidth = computedStyle.maxWidth,
          maxHeight = computedStyle.maxHeight,
          minWidth = computedStyle.minWidth,
          minHeight = computedStyle.minHeight;
      var maxRatio = Math.min(parseInt(maxWidth) / w, parseInt(maxHeight) / h);
      var minRatio = Math.max(parseInt(minWidth) / w, parseInt(minHeight) / h);
      var isScalingDown = maxRatio < 1;
      var scale = isScalingDown ? maxRatio : minRatio > 1 ? minRatio : 1;

      var _getOrInsertCSSRule = getOrInsertCSSRule(this.shadowRoot, ":host"),
          style = _getOrInsertCSSRule.style;

      var imgStyle = getOrInsertCSSRule(this.shadowRoot, "img").style;
      var img = this.shadowRoot.querySelector("img");
      var extremum = isScalingDown ? "min" : "max";
      style.setProperty("".concat(extremum, "-width"), "initial", "important");
      style.setProperty("".concat(extremum, "-height"), "initial", "important");
      style.width = "".concat(w * scale, "px");
      style.height = "".concat(h * scale, "px");

      var resize = function resize() {
        imgStyle.width = "".concat(_this2.imgWidth * scale, "px");
        imgStyle.height = "".concat(_this2.imgHeight * scale, "px");
        imgStyle.display = "block";
      };

      if (img.src !== src) {
        img.onload = function () {
          _this2.imgWidth = img.naturalWidth;
          _this2.imgHeight = img.naturalHeight;
          resize();
        };

        img.src = src;
        resize();
      }

      resize();
      imgStyle.transform = "translate(-".concat(x * scale, "px, -").concat(y * scale, "px)");
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [MediaStateReceiverAttributes.MEDIA_CONTROLLER, MediaUIAttributes.MEDIA_PREVIEW_IMAGE, MediaUIAttributes.MEDIA_PREVIEW_COORDS];
    }
  }]);

  return MediaPreviewThumbnail;
}(globalThis.HTMLElement);

_mediaController = new WeakMap();

if (!globalThis.customElements.get("media-preview-thumbnail")) {
  globalThis.customElements.define("media-preview-thumbnail", MediaPreviewThumbnail);
}

var media_preview_thumbnail_default = MediaPreviewThumbnail;
export { media_preview_thumbnail_default as default };